import { render } from "./AttachmentPreviewDialog.vue?vue&type=template&id=7540353c&scoped=true"
import script from "./AttachmentPreviewDialog.vue?vue&type=script&lang=js"
export * from "./AttachmentPreviewDialog.vue?vue&type=script&lang=js"

import "./AttachmentPreviewDialog.vue?vue&type=style&index=0&id=7540353c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7540353c"]])

export default __exports__